import { isDevMode } from '@angular/core';
import { ActionReducer } from '@ngrx/store';

let actionCount = 0;
let lastActionTime = Date.now();

const MAX_ACTIONS_PER_SECOND = 200;

export function circuitBreakerMetaReducer(
  reducer: ActionReducer<any>,
): ActionReducer<any> {
  return (state, action) => {
    if (!isDevMode()) {
      return reducer(state, action);
    }

    if (action.type.startsWith('@ngrx')) {
      return reducer(state, action);
    }

    const now = Date.now();

    if (now - lastActionTime > 1000) {
      actionCount = 0;
      lastActionTime = now;
    }

    actionCount++;

    if (actionCount > MAX_ACTIONS_PER_SECOND) {
      console.error('🔥 INFINITE LOOP DETECTED IN NGRX!');
      console.error('Last action dispatched:', action.type);
      console.error('Current state:', state);
      throw new Error(
        `NgRx Circuit Breaker: More than ${MAX_ACTIONS_PER_SECOND} actions per second. Loop contained.`,
      );
    }

    return reducer(state, action);
  };
}
